/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'

import {
  EuiDescriptionListTitle,
  EuiDescriptionListDescription,
  EuiText,
  EuiToolTip,
  EuiIcon,
  EuiFlexGroup,
  EuiFlexItem,
} from '@elastic/eui'

import { FormattedMessage } from '@modules/i18n'
import type { TrafficFilterRulesetInfo } from '@modules/cloud-api/v1/types'

interface Props {
  ruleset: TrafficFilterRulesetInfo
}

const IncludedByDefaultDetail: React.FC<Props> = ({ ruleset }) => (
  <React.Fragment>
    <EuiDescriptionListTitle>
      <EuiFlexGroup gutterSize='s' alignItems='center'>
        <EuiFlexItem grow={false}>
          <FormattedMessage id='trafficFilterDetail.includedByDefault' defaultMessage='Default' />
        </EuiFlexItem>
        <EuiFlexItem grow={false}>
          <EuiToolTip
            content={
              <FormattedMessage
                id='trafficFilterDetail.includedByDefaultTooltip'
                defaultMessage='Any future eligible resource will be applied this IP filter automatically.'
              />
            }
            position='right'
          >
            <EuiIcon type='question' />
          </EuiToolTip>
        </EuiFlexItem>
      </EuiFlexGroup>
    </EuiDescriptionListTitle>
    <EuiDescriptionListDescription>
      <EuiText size='s'>
        {ruleset.include_by_default ? (
          <FormattedMessage id='trafficFilterDetail.yes' defaultMessage='Yes' />
        ) : (
          <FormattedMessage id='trafficFilterDetail.no' defaultMessage='No' />
        )}
      </EuiText>
    </EuiDescriptionListDescription>
  </React.Fragment>
)

export default IncludedByDefaultDetail
